<template>
	<section
		class="content"
		id="product-list-slider"
	>
			<div class="sec-title">
				<h4 id="all-product-title"
								data-test="productListSliderHeading">
					{{title}}
				</h4>
				<a
					href="#"
					@click.prevent="viewAllProducts"
					id="view-all-link"
					class="btn btn-primary wp_viewAllBtn"
					data-test="productListSliderViewAllLink"
				>
					View All
				</a>
			</div>
			<!-- /divider -->
			<!-- prdts -->
			<div class="home-products">
				<div class="owl-one owl-carousel owl-theme owl-loaded">
					<div class="owl-stage-outer">
						<div class="owl-stage">
							<div
								class="owl-item"
								v-for="(product,key) in products"
								:key="key"
							>
								<a
									href="#"
									@click.prevent="redirectToProductDetails(product.product_id,product)"
									class="hp-prdt"
									v-if="product && product.product_details &&
                   product.product_details.image_URL_1"
									:id="'product-redirect-link-'+key"
									:data-test="'productListSliderLink1'+key"
								>
									<out-of-stock v-if="!(product.vendor_product_inventories &&
                          product.vendor_product_inventories[0]) ||
                        (product.vendor_product_inventories[0].available_stock < 1)">
									</out-of-stock>
									<img
										class="hp-prdt-img"
										alt="Product Image"
										:src=product.product_details.image_URL_1
										:id="'product-img-'+key"
										:data-test="'productListSliderPdtImg1'+key"
									/>
									<h6
										class="hp-prdt-name allproductslider-name"
										v-if="product.product_name"
										:id="'product-name-'+key"
										:data-test="'productListSliderPrdtName'+key"
									>
										{{product.product_name}}
									</h6>
									<div
										class="allproductslider-pricing"
										:id="'product-price-'+key"
										v-if="product.promotion && product.promotion.promotion_id"
										style=""
									>
										<div
											:id="'product-price-'+key+'-price'"
											class="hp-prdt-price"
											style=" white-space: nowrap;"
											:data-test="'productListSliderPromoPrice'+key"
										>
											{{product.promotion.promotion_applied_price |
											currencyConversion}}
										</div>
										<div
											:id="'product-price-'+key+'-discount'"
											class=" hp-prdt-price"
											style="text-decoration: line-through;
                                 color: gray; white-space: nowrap;"
											:data-test="'productListSliderViPrice'+key"
										>
											{{product.vpi.price | currencyConversion}}
										</div>
										<div
											:id="'product-price-'+key+'-discount-percent'"
											class="hp-prdt-price"
											style="color: green;"
											v-if="product.promotion &&
                         product.promotion.promotion_id"
											:data-test="'productListSliderPromoPercent'+key"
										>
											{{product.promotion.promotion_percentage}}% off
										</div>
									</div>
									<div
										class="allproductslider-pricing"
										v-else-if="(product.vendor_product_inventories &&
                          product.vendor_product_inventories[0] &&
                          product.vendor_product_inventories[0].price)"
									>
										<div class="hp-prdt-price"
															:data-test="'productListSliderVendorPrice'+key">
											{{product.vendor_product_inventories[0].price |
											currencyConversion}}
										</div>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
	</section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { customerApi } from '@/services/ApiServices/customerApi'
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'

export default {
	components: {
		OutOfStock
	},

	computed: {
		...mapGetters('user', ['isAuthenticated'])
	},
	mounted () {
		/* Mount the Owl carousel */
		this.owlCarouselInitialization()
	},
	data () {
		return {
			productArray: {},
			recommendProductCount: 100
		}
	},
	props: {
		products: Array,
		title: String
	},
	methods: {
		...mapActions('productselected', ['setSelectedProductData']),
		...mapActions('recentview', ['setRecentProductsData']),
		owlCarouselInitialization () {
			$('.owl-one').owlCarousel({
				rtl: false,
				loop: false,
				margin: 10,
				dots: false,
				stagePadding: 24,
				lazyLoad: true,
				nav: true,
				navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
				responsive: {
					0: {
						items: 2,
						nav: true
					},
					576: {
						items: 2,
						nav: false
					},
					768: {
						items: 3,
						nav: true
					},
					992: {
						items: 4,
						nav: true
					},
					1200: {
						items: 6,
						nav: true
					}
				}
			})
		},
		redirectToProductDetails (productId, product) {
			this.setRecentProductsData(productId)
			this.setSelectedProductData(product)
			if (this.isAuthenticated) {
				customerApi.insertRecentlyViewedProducts(productId).then((res) => {

				}).catch((e) => {

				})
			}
			if (product.vendor_product_inventories &&
					product.vendor_product_inventories[0] &&
					product.vendor_product_inventories[0].promotional_prices) {
				this.$router.push({
					name: 'ProductDetails',
					path: '/product_description',
					query: {
						productName: product.product_name,
						productId: product.product_id,
						productCategoryId: product.product_category_id,
						promotionId: product.vendor_product_inventories[0].promotional_prices.promotion_id
					}
				})
			} else {
				this.$router.push({
					name: 'ProductDetails',
					path: '/product_description',
					query: {
						productName: product.product_name,
						productId: product.product_id,
						productCategoryId: product.product_category_id
					}
				})
			}
		},
		viewAllProducts () {
			switch (this.title) {
			case 'All Products': {
				this.$router.push({
					name: 'AllProducts',
					path: '/all-products',
					query: {
						display_text: 'All Products',
						called_index_value: this.index_start,
						called_count_value: this.count_index,
						product_length: this.products.length
					}
				})
				break
			}
			case 'Recommended Products': {
				this.$router.push({
					name: 'RecommendProducts',
					path: '/recommend-products',
					query: {
						display_text: 'Recommended Products',
						recommendProductCount: this.recommendProductCount
					}
				})
			}
			}
		}
	},
	watch: {
		products: {
			handler (val) {
				this.owlCarouselInitialization()
			},
			deep: true
		}
	}
}
</script>
